import { render, staticRenderFns } from "./myStudentDialog.vue?vue&type=template&id=10d5c849"
import script from "./myStudentDialog.vue?vue&type=script&lang=js"
export * from "./myStudentDialog.vue?vue&type=script&lang=js"
import style0 from "./myStudentDialog.vue?vue&type=style&index=0&id=10d5c849&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports